import React from 'react'
import NavigationBar from '../components/NavigationBar';
import update from 'immutability-helper';
import Auth from '../config/Auth';
import { Container, Row, Col, Modal, Card, CardBody, Label, Button, Spinner, ModalBody, FormGroup, Input, ModalFooter, UncontrolledAlert } from 'reactstrap';
import { database, storage } from '../firebase';
import InputGroup from 'reactstrap/lib/InputGroup';

class Lista extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      enviado: null,
      tempoRestante: null,
      title: props.title,
      params: {
        id: this.props.match.params.id !== null ? this.props.match.params.id : '',
      },
      nomeA: '',
      nomeB: '',
      nomeC: '',
      vip: false,
      festa: null
    }

    this.handleTextChange = this.handleTextChange.bind(this);

    this.post = this.post.bind(this);
    this.restart = this.restart.bind(this);
    this.toggleVip = this.toggleVip.bind(this);
    this.getHorasRestantes = this.getHorasRestantes.bind(this);
  }

  componentDidMount() {
    if (this.state.params.id !== null && this.state.params.id !== '') {
      this.loadFesta(this.state.params.id);
    }
  }

  toggleVip(){
    const isVip = !this.state.vip
    this.setState(state => update(state, {
      vip: { $set: isVip }
    }))
  }

  handleTextChange(e) {
    let name = e.target.name;
    let value = e.target.value;

    if (name == "nomeA") {
      this.setState(state => update(state, {
        nomeA: { $set: value }
      }))
    }
    else if (name == "nomeB") {
      this.setState(state => update(state, {
        nomeB: { $set: value }
      }))
    }
    else if (name == "nomeC") {
      this.setState(state => update(state, {
        nomeC: { $set: value }
      }))
    }
  }

  loadFesta(id) {
    console.log('loadFesta(' + id + ')')
    this.setState(state => update(state, {
      isLoading: { $set: true }
    }), () => {
      database.ref('festas').child(id).once('value', (snap) => {
        var festa = snap.val()

        this.setState(state => update(state, {
          isLoading: { $set: false },
          festa: { $set: festa }
        }))

        this.loadImage('full');
      }, (error) => {
        console.log(error);
      })
    })
  }

  restart() {
    this.setState(state => update(state, {
      isLoading: { $set: false },
      enviado: { $set: null },
      nomeA: { $set: "" },
      nomeB: { $set: "" },
      nomeC: { $set: "" },
    }))
  }

  listaDisponivel(festaTimestamp, listaAte) {
    const currentTimestamp = parseInt(Date.now() / 1000);
    const listaLimite = parseInt(festaTimestamp + ((listaAte !== undefined ? listaAte : 2) * 60 * 60) / 1000);

    this.getHorasRestantes(currentTimestamp <= listaLimite ? listaLimite - currentTimestamp : 0)

    return (currentTimestamp <= listaLimite)
  }

  getHorasRestantes(segundos) {
    if (this.state.tempoRestante === null) {
      var restante = "Lista encerrada"

      if (segundos < 60) {
        restante = segundos + " segundos restantes";
      }
      else if (segundos / 60 < 60) {
        restante = parseInt(segundos / 60) + " minutos restantes";
      }
      else if (segundos / 60 / 60 < 24) {
        restante = parseInt(segundos / 60 / 60) + " horas restantes";
      }
      else if (segundos / 60 / 60 / 24 < 30) {
        restante = parseInt(segundos / 60 / 60 / 24) + " dias restantes";
      }
      else if (segundos / 60 / 60 / 24 / 30 ) {
        restante = parseInt(segundos / 60 / 60 / 24 / 30)  + " meses restantes";
      }

      this.setState(state => update(state, {
        tempoRestante: { $set: restante }
      }))
    }
  }

  post(vipTimestamp) {
    this.setState(state => update(state, {
      isLoading: { $set: true },
      enviado: { $set: null }
    }), () => {
      var nomes = []
      if (this.state.nomeA.length > 4) nomes.push(this.state.nomeA);
      if (this.state.nomeB.length > 4) nomes.push(this.state.nomeB);
      if (this.state.nomeC.length > 4) nomes.push(this.state.nomeC);

      var restante = 0;

      const reference = database.ref('listas/').child(this.state.params.id).child('nomes');

      for (var i = 0; i < nomes.length; i++) {
        const nome = nomes[i].trim();
        
        if (nome !== undefined && nome !== "") {
          const key = reference.push().key;
          restante += 1;

          reference.child(key).set(nome + (this.state.vip ? " (Vip: " + vipTimestamp + ")" : ""), ((error) => {
            if (error === null) {
              restante -= 1;

              if (restante === 0) {
                this.setState(state => update(state, {
                  isLoading: { $set: false },
                  enviado: { $set: true },
                }));
              }
            }
        }))
        }
      }
    })
  }

  loadImage(id) {
    if (this.state.festa.info.flyer !== undefined) {
      const path = this.state.festa.info.flyer;

      if (path.includes('http') || path.includes('https')) {
        setTimeout(function () {
          document.getElementById(id).innerHTML = "<img src='" + path + "' className='card-img-top' style='max-width:100%;' />";
        }, 500);
      }
      else {
        storage.child(this.state.festa.info.flyer).getDownloadURL().then(
          (url) => {
            document.getElementById(id).innerHTML = "<img src='" + url + "' className='card-img-top' style='max-width:100%;' />";
          },
          (error) => {
            console.log(error)
          });
        }
    }
  }

  render() {
    var nome = "";
    var listaDisponivel = false;
    var sobre = "";
    var dataHoraString = "";
    var localString = "";
    var timestamp = 0;

    if (this.state.festa != null) {
      const item = this.state.festa;
      nome = (item.info.nome !== undefined && item.info.nome !== '') ? item.selo.info.nome + ' - ' + item.info.nome : item.selo.info.nome;
      const key = item.key
      const lista = item.lista.disponivel !== undefined ? item.lista.disponivel : null;
      sobre = (item.info.sobre)

      console.log(item.info.dataTimestamp + " || " + item.lista.info.disponivelHorasAntes)

      if (item.info.dataTimestamp !== undefined) {
        timestamp = parseInt(item.info.dataTimestamp / 100)
        listaDisponivel = this.listaDisponivel(item.info.dataTimestamp, item.lista.info.disponivelHorasAntes);
      }

      const local = item.local;
      var enderecoString = "";
      if (local !== undefined) {
        enderecoString += local.endereco.logradouro;
        enderecoString += "\n";
        localString = item.local.info.nome;
        if (local.endereco.cidade !== undefined && local.endereco.uf !== undefined) enderecoString += local.endereco.cidade + " / " + local.endereco.uf;
        if (local.endereco.cep !== undefined) enderecoString += "\nCEP: " + local.endereco.cep;
        if (local.info.telefone !== undefined) enderecoString += "\n\nTelefone: " + local.info.telefone;
        if (local.info.servico !== undefined && local.info.servico !== "") enderecoString += "\n\n" + local.info.servico;
      }

      const dataHora = new Date(item.info.dataHora);
      if (dataHora !== undefined) {
        dataHoraString = dataHora.toLocaleDateString().substr(0, 5)  + ' às ' + dataHora.toLocaleTimeString().substr(0, 5) + " - " + localString
      }
    }

    return (
      <React.Fragment>
        <NavigationBar /> 
        <Container className="container-sm" >{
      this.state.isLoading ?
        <Row className="pl-0 pr-0 ml-0 mr-0 pt-1">
          <Col xs={12} className="text-center pl-0 pr-0 ml-0 mr-0" >
            <Button color="dark" style={{ margin: 0 + " auto", float: 'none' }} className="m-1" disabled onClick={this.loadFestas}><Spinner className="spinner-grow spinner-grow-sm"></Spinner> Aguarde...</Button>
          </Col>
        </Row>
      :
        this.state.festa !== null ?
          listaDisponivel ? 
            <React.Fragment>
              <Row className="pl-0 pr-0 ml-0 mr-0 pt-1" >
                <Col>
                    <Container>
                      <Row className="pl-0 pr-0 ml-0 mr-0 pt-1">
                        <Col xs={12} md={6}>
                <div id={"full"} className="m-1" /> </Col>
                        <Col xs={12} md={6}>
                <Card className="m-1">
                  <CardBody> <p className="h4">{nome}</p>
                  <p className="text-secondary"> { dataHoraString }</p>
                  <p className="text-secondary"> {
                    sobre.split("\n").map(function (text, idx) {
                      return (
                        <span key={idx}>
                          {text}
                          <br />
                        </span>
                      )
                    })
                  }
                </p>
                  </CardBody>
                </Card>
                </Col>
                <Col xs={12}>
                <Card className="m-1">
                  <CardBody> 
                    <p className="h5">Lista</p>{
                    this.state.enviado === null ?
                      <React.Fragment>
                        <p className="text-secondary">Digite os nomes separados por vírgula</p>
                        <FormGroup>
                          {
                            Auth.isAuthenticated ?
                            <React.Fragment>
                              <InputGroup className="mb-1 ">
                                <Input className="mr-1" type="text" maxLength={50} name="nomeA" onChange={this.handleTextChange} value={this.state.nomeA} />
                                <Button color={this.state.vip ? "primary" : "secondary"} onClick={this.toggleVip}>Vip</Button>
                              </InputGroup>
                              <InputGroup className="mb-1 ">
                                <Input className="mr-1"  type="text" maxLength={50} name="nomeB" onChange={this.handleTextChange} value={this.state.nomeB} />
                                <Button color={this.state.vip ? "primary" : "secondary"} onClick={this.toggleVip}>Vip</Button>
                              </InputGroup>
                              <InputGroup className="mb-1 ">
                                <Input className="mr-1"  type="text" maxLength={50} name="nomeC" onChange={this.handleTextChange} value={this.state.nomeC} />
                                <Button color={this.state.vip ? "primary" : "secondary"} onClick={this.toggleVip}>Vip</Button>
                              </InputGroup>
                              <p className='body text-secondary'>Código <b>VIP</b> do evento: <b>{timestamp.toString()}</b></p>
                            </React.Fragment>
                              :
                            <React.Fragment>
                              <Input className="mb-1" type="text" maxLength={50} name="nomeA" onChange={this.handleTextChange} value={this.state.nomeA} />
                              <Input className="mb-1" type="text" maxLength={50} name="nomeB" onChange={this.handleTextChange} value={this.state.nomeB} />
                              <Input className="mb-1" type="text" maxLength={50} name="nomeC" onChange={this.handleTextChange} value={this.state.nomeC} />
                            </React.Fragment>
                          }
                        </FormGroup>
                      </React.Fragment>
                    :
                      <UncontrolledAlert color="success">Nome(s) enviados com sucesso!</UncontrolledAlert>
                  }{
                    this.state.enviado === null ? 
                      this.state.nomeA.length > 4 || this.state.nomeB.length > 4 || this.state.nomeC.length > 4 ?
                        <Button color="primary" onClick={() => { this.post(timestamp.toString()) }}>Enviar</Button>
                      :
                        <Button color="primary" disabled onClick={this.post}>Enviar</Button>
                    :
                      <Button color="secondary" onClick={this.restart}>Ok</Button>
                  }
                  </CardBody>
                  </Card>
                </Col>
                </Row>
              </Container>
                 
                </Col>
              </Row>
            </React.Fragment>
          :
            <UncontrolledAlert color="warning" className="text-center mt-1">Lista encerrada.</UncontrolledAlert>

        :
          <UncontrolledAlert color="danger" className="text-center mt-1">Evento não encontrado. Tente novamente.</UncontrolledAlert>
      }
    </Container>
      </React.Fragment>
    )
  }
}

export default (Lista)